import React, {Component} from "react"
import {Link, browserHistory} from "react-router"
import {Form, Card, FormField, FormInput, ButtonGroup, Button} from "elemental"
import shop from "shop/shop"

class RequestPasswordPage extends Component {

  state = {
    response:  false,
    email:     "",
    password0: "",
    password1: ""
  }

  componentDidMount() {
    console.log( `PW RESET` )
    let { location }    = this.props
    let { key, subkey } = location.query
    if ( key && subkey ) {
      this.setState( { key, subkey } )
      console.log( `key`, key )
    }
  }

  setEmail = (e) => {
    this.setState( { email: e.target.value } )
  }

  resetPassword = (e) => {
    const ERRORS_PW = {
      TO_SHORT:  1,
      NOT_EQUAL: 2
    }

    const key                 = this.props.location.query.key
    const subkey              = this.props.location.query.subkey
    const password            = this.state.password0
    const password_validation = this.state.password1

    let flag = false

    if ( password !== password_validation ) flag = ERRORS_PW.NOT_EQUAL
    if ( password && password.length < 4 ) flag = ERRORS_PW.TO_SHORT

    if ( flag === ERRORS_PW.TO_SHORT ) {
      window.swal( translate( "reset.too_short" ), translate( "reset.too_short_explained" ), "error" )
      return
    }

    if ( flag === ERRORS_PW.NOT_EQUAL ) {
      window.swal( translate( "reset.passwords_not_equal" ), translate( "reset.passwords_not_equal_explained" ), "error" )
      return
    }

    // jQuery.ajax({ url: '/shop/rest/security/resetpass',data: JSON.stringify({"subkey":1,"key":"25576688485240761757","password":"neuesPass"}), type: 'POST', processData: false, contentType: false });
    e.preventDefault()

    shop.resetPassword( { key, password, subkey } )
      .then( onSuccess )
      .catch( onError )

    return false
  }

  requestPassword = (e) => {
    const { email } = this.state

    shop.requestPassword( email )
      .then( response => {
        if ( response ) {
          window.swal( translate( "reset.success" ), translate( "reset.success_explained", { email } ),
            "success" )
          this.setState( { response } )
        }
      } )
      .catch( e => {
        window.swal( translate("reset.mail_not_found"), translate("reset.mail_not_found_explained"), "error" )
      } )

    e.preventDefault()
    return false
  }

  render() {
    const { email } = this.state
    const key       = this.props.location.query.key
    const subkey    = this.props.location.query.subkey

    return (
      <div>
        <div className="mw6 center pt5 ">
          {/*REQUEST RESET*/}
          {!key && !subkey && <Card className="overflow-hidden">
            <h3>{translate( "reset.reset" )}</h3>
            <Form onSubmit={this.requestPassword}>
              <FormField label={translate( "reset.your_mail" )} htmlFor="basic-form-input-email">
                <FormInput value={email}
                           onChange={this.setEmail}
                           autoFocus
                           type="email" required placeholder={translate()}
                           name="basic-form-input-email"/>
              </FormField>
              <div className="">
                <Button className="fr mb3" type="primary" submit>{translate( "reset.reset" )}</Button>
                <Link to="/login"> <Button type="default">{translate( "reset.back" )}</Button></Link>
              </div>
            </Form>
          </Card>}

          {/*RESET PASSWORD */}
          {key && subkey && <Card className="overflow-hidden">
            <h3>{translate( "reset.choose_password" )}</h3>
            <Form onSubmit={(e) => {
              e.preventDefault()
              return false
            }}>
              <FormField label={translate( "reset.your_new_password" )} htmlFor="basic-form-input-email">
                <FormInput value={this.state.password0}
                           onChange={(e) => { this.setState( { password0: e.target.value } )}}
                           type="password" required
                           name="basic-form-input-email"/>
              </FormField>

              <FormField label={translate( "reset.repeat_password" )} htmlFor="basic-form-input-email">
                <FormInput value={this.state.password1}
                           onChange={(e) => { this.setState( { password1: e.target.value } )}}
                           type="password" required
                           name="basic-form-input-email"/>
              </FormField>

              <div className="">
                <Button submit onClick={this.resetPassword} className="fr mb3" type="primary">{translate( "reset.set_password" )}</Button>
              </div>
            </Form>
          </Card>}
        </div>
      </div>
    )
  }
}

function onSuccess() {
  browserHistory.push( "/login" )
  window.swal( "Reset  erfolgreich", "Sie können sich nun mit ihrem neuen Passwort anmelden.", "success" )
}

function onError(err) {
  console.warn( `error`, err )
  window.swal( "Reset nicht erfolgreich", "Es trat leider ein unbekannter Fehler auf.", "error" )
}

export default RequestPasswordPage



// WEBPACK FOOTER //
// ./src/theme/pages/RequestPasswordPage.js